var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:[_vm.childClass, 'btn btn-pdv btn-pdv-red'],attrs:{"disabled":_vm.busy},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.getI18n('COMMON.cancel'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }